import { Component, effect, input, ChangeDetectionStrategy } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { Genus } from '@xanadu/model';

@Component({
    selector: 'app-preview',
    templateUrl: './preview.component.html',
    styleUrls: ['./preview.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PreviewComponent {
    formGroup = input<FormGroup>();
    node = input<Genus>();

    metaOption: any = { label: { id: 'name', name: 'Preview Name' }, value: { id: 'path', name: 'Preview Path' } };

    previewGroup = new FormGroup({});
    contentArray: FormArray<FormGroup> = new FormArray<FormGroup>([]);
    genusArray: FormArray<FormGroup> = new FormArray<FormGroup>([]);

    constructor() {
        effect(() => {
            const node = this.node();
            const formGroup = this.formGroup();

            if (node && formGroup) {
                formGroup.addControl('preview', this.previewGroup);
                this.previewGroup.addControl('content', this.contentArray);
                this.previewGroup.addControl('genus', this.genusArray);

                if (node.preview?.content?.length) {
                    this.contentArray.clear();
                    node.preview.content.forEach(() => this.contentArray.push(new FormGroup({})));
                }
                if (node.preview?.genus?.length) {
                    this.genusArray.clear();
                    node.preview.genus.forEach(() => this.genusArray.push(new FormGroup({})));
                }
            }
        });
    }

    onContent() {
        const node = this.node();

        if (node) {
            if (!node?.preview?.content) {
                node.preview = node.preview || {};
                node.preview.content = [];
            }
            node.preview.content.push({});
            this.contentArray.push(new FormGroup({}));
            this.formGroup()?.markAsDirty();
        }
    }

    onGenus() {
        const node = this.node();

        if (node) {
            if (!node?.preview?.genus) {
                node.preview = node.preview || {};
                node.preview.genus = [];
            }
            node.preview.genus.push({});
            this.genusArray.push(new FormGroup({}));
            this.formGroup()?.markAsDirty();
        }
    }

    onDeleteContent($event: any) {
        const node = this.node();

        if (node?.preview?.content?.length) {
            const index = node.preview.content.findIndex((x: any) => x === $event);
            node.preview.content?.splice(index, 1);
            this.contentArray.removeAt(index);
            this.formGroup()?.markAsDirty();
        }
    }

    onDeleteGenus($event: any) {
        const node = this.node();

        if (node?.preview?.genus?.length) {
            const index = node.preview.genus.findIndex((x: any) => x === $event);
            node.preview.genus?.splice(index, 1);
            this.genusArray.removeAt(index);
            this.formGroup()?.markAsDirty();
        }
    }
}
